import TableHead from '@mui/material/TableHead';
import type { FC, ReactNode } from 'react';

interface TableHeadProps {
    id: string;
    children?: ReactNode;
    className?: string;
}

const CustomTableHead: FC<TableHeadProps> = ({
  id,
  children,
  className,
  ...rest
}) => {

  return (
    <TableHead
      id={id}
      className= {className}
      {...rest}
    >
      {children}
    </TableHead>
  );
}

export default CustomTableHead